import { Outlet } from 'react-router-dom'
import Login from '../pages/Login'
import { useSelector } from 'react-redux'

export default function LoggedInRoutes() {
  const { user } = useSelector((state) => ({ ...state }))
  return user ? <Outlet /> : <Login />
}
